module.exports = __webpack_public_path__ + "static/media/Lindholmsforbindelsen.e04b4f43.png";